import styled from "styled-components";
import {TextField} from "@mui/material";

export const Input = styled(TextField)`
	width: 100%;

	&& * {
		font-family: "Hind", sans-serif;
	}

	&& label {
		top: -5px;
		color: rgba(0, 0, 0, 0.6);
	}

	& .MuiFilledInput-root:after,
	& .MuiFilledInput-root:before {
		border-bottom-color: rgba(0, 0, 0, 0.42);
	}

	& fieldset {
		border-color: rgba(0, 0, 0, 0.42);
	}

	&:hover fieldset {
		border-color: rgba(0, 0, 0, 0.42);
	}

	&.Mui-focused fieldset {
		border-color: rgba(0, 0, 0, 0.42);
	}
`;
